<template>
  <div class="processedDetail">
    <div style="font-size: 24px;margin-bottom: 20px;font-weight: bold;">{{$t('other.a2162')}}/{{$t('other.a67')}} ---{{$t('other.a2163')}}</div>
    <dxs-Cell :btnOptions="list" :title="$t('other.a1827')" @handleClick="getStore"></dxs-Cell>
    <div class="IdScaneArea">
      <!-- 扫仓库编码 -->
      <el-input
        size="mini"
        ref="scan"
        v-model="productCoding"
        :placeholder="$t('homeTwo.scanProduct')"
        @change="getBarCode()"
      ></el-input>
    </div>
    <div class="ppo_box">
      <div class="titl_desc_right">
          <el-button size="medium" type="danger" @click="printCode()">{{$t('other.a2164')}}</el-button>
        
      </div>
    </div>

    <el-table
      ref="multipleTable"
      :data="tableList"
      tooltip-effect="dark"
      border
      style="width: 100%;margin-bottom: 50px;"
      select-all="checkedall"
      @selection-change="handleSelectionChange"
    >
      <el-table-column label="Product(s)" width="100">
        <template slot-scope="scope">
          <span>
            <img :src="scope.row.image" />
          </span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('other.a2165')" width="100">
        <template slot-scope="scope">
          <span>
            <img :src="scope.row.codeUrl" />
          </span>
        </template>
      </el-table-column>

      <el-table-column prop="address" :label="$t('homeTwo.cusCode')" show-overflow-tooltip>
        <template slot-scope="scope">
          <div class="orderInfo">
            <div
              class="bvmt"
            >{{scope.row.cusCode}}({{scope.row.encoding ? scope.row.encoding : $t('other.a887')}})</div>
            <div class="bvmt sbti">sku:{{scope.row.skuName}}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="address" :label="$t('other.a1522')" show-overflow-tooltip>
        <template slot-scope="scope">
          <div class="orderInfo">
            <div class="bvmt sbti">1</div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import userStoreItems from "../../api/moudles/userStoreItems";
import newOrder from "../../api/moudles/newOrders";
import utils from "../../utils/utils.js";
export default {
  data() {
    return {
      tableList: [],
      tableListCopy: [],
      shopInfo: null,
      orders: {},
      textarea: "",
      returntextarea: null,
      scanNum: "",
      diaReturnOrder: false,
      packTime: null,
      shopee: null,
      productCoding: "",
      tableList: [],
      processedList: [],
      orderParam: {
        actualNum: 0,
        orderId: this.$t('other.a354'),
        userId: this.$t('other.a354'),
        totalPurchase: 0
      },
      list:[],
      storeId:null
    };
  },
  directives: {
    //注册一个局部的自定义指令 v-focus
    focus: {
      // 指令的定义
      inserted: function(el) {
        // 聚焦元素
        el.querySelector("scan").focus();
      }
    }
  },
  computed: {
    ...mapState({
      userId: state => state.login.userInfo.userId || ""
    }),

    totalPicklist() {
      let list = 0;
      this.tableList.forEach(p => {
        p.children.forEach(k => {
          list += k.pickingNum;
        });
      });

      return list;
    },

    actualPicklist() {
      let list = 0;
      this.tableList.forEach(p => {
        p.children.forEach(k => {
          list += k.purcahseQty;
        });
      });

      return list;
    }
  },
  watch: {
    diaReturnOrder() {
      if (!this.diaReturnOrder) {
        this.returntextarea = null;
      }
    }
  },
  created() {
    this.hfkf();
    this.getBtnOptions()
  },
  methods: {
    ...mapActions("processed", [
      "getProcessedOrderSn",
      "getProcessedOrderInfo",
      "getIDacountProcessedList",
      "getPackagedOrderByStore", //仓库帐号下猎取已出库出库的订单
      "setPackaged",
      "setPackagedCopy",
      "getProcessedOrders",
      "getLogisticsBystore",
      "getLogisticsByseller",
      "getProcessedOrderBySeller",
      "getProcessedOrderByStore"
    ]),

    getBtnOptions(){
      let stores=JSON.parse(localStorage.getItem('userInfo')).stores
      let store=[]
        if(stores){
            //筛选所有启用的海外仓
            for(let i=0;i<stores.length;i++){
                if(stores[i].storeType !== 4 && stores[i].isUsed){
                  store.push({
                    label:stores[i].storeName,
                    value:stores[i].storeId,
                  })
                }
            }  
        }
      this.list=store
      this.storeId=this.list[0].value

      console.log('store',store)
    },

    getStore(item){
      console.log(item)
      this.storeId=item.value
    },

    printCode() {
      utils
        .updateInfoByCache({
          cacheKey: "scanBarCode",
          userId: this.userId,
          cacheData: JSON.stringify(this.tableList)
        })
        .then(res => {
          let routeData = this.$router.resolve({
            name: "scanBarCode"
          });


          window.open(routeData.href, "_blank");
        });
    },

    //获取二维码
    getBarCode() {
      if(!this.productCoding){
        return
      }
      newOrder
        .getCodeByGroupId({
          cuscode: this.productCoding,
          storeId:this.storeId
        })
        .then(res => {
          if (res.code === 200) {
            console.log("desc", res.data);
            const resultData = res.data || {};
            if (resultData) {
              this.tableList.push({
                ...resultData.sku,
                codeUrl: resultData.codeUrl
              });
              this.productCoding = "";
            }
          } else {
            this.$message.warning(res.msg);
          }
        });
    },

    returnOrder() {
      if (!this.returntextarea) {
        this.$message.warning(this.$t("homeTwo.retrunDesc"));
        return;
      }

      if (!this.orderParam.orderId) {
        this.$message.warning(this.$t("homeTwo.noorderdata"));
        return;
      }
      this.orders.msg = this.returntextarea;

      newOrder.cancelAuditedOrders([this.orders]).then(res => {
        if (res.code === 200) {
          this.$message.success("Successfully returned review");
          this.diaReturnOrder = false;
          this.resetOrder();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },

    outProduct() {
      console.log("tableList", this.tableList);
    },

    resetOrder() {
      this.tableList = [];
      this.orderParam = {
        actualNum: 0,
        orderId: this.$t('other.a354'),
        userId: this.$t('other.a354'),
        totalPurchase: 0
      };
    },

    reset() {
      this.tableList.forEach(p => {
        p.children.forEach(k => {
          k.pickingNum = 0;
        });
      });
    },

    //订单内单品套餐都含有同一个产品编码的扫描判断
    scanCuscodeNum(productcode) {
      let list = [];
      let code = productcode.replace(/\s*/g, "");
      let array = this.tableList;
      array.forEach((p, index) => {
        p.children.forEach(k => {
          k.encoding = k.encoding ? k.encoding.replace(/\s*/g, "") : k.encoding;
          if (k.cusCode == code || k.encoding == code) {
            list.push(index);
          }
        });
      });
      return list;
    },

    //产品条形码扫描
    scanProductCoding() {
      this.productCoding = this.productCoding.replace(/\s*/g, "");
      console.log(this.productCoding);
      console.log(this.tableList);

      newOrder
        .getCodeByGroupId({
          cuscode: this.productCoding
        })
        .then(res => {
          if (res.code === 200) {
            console.log("desc", res.data);
          } else {
            this.$message.warning(res.msg);
          }
        });
    },

    packBageOutCopy() {
      this.scanNum = this.scanNum.replace(/\s*/g, "");
      if (this.scanNum) {
        this.tableList = [];
        this.orderParam.totalPurchase = 0;
        newOrder
          .getOrderInfoByScan({
            orderId: this.scanNum,
            userId: this.userId,
            storeIds: JSON.parse(localStorage.getItem("userInfo")).storeIds
          })
          .then(res => {
            if (res.code === 200) {
              if (!res.data) {
                this.$message.warning(this.$t("homeTwo.systemNoorder"));
                setTimeout(() => {
                  this.scanNum = "";
                }, 200);
                return;
              }
              let mapList = new Map();
              console.log(res.data);
              this.orderParam.orderId = res.data.orderId;
              this.orderParam.logistics = res.data.logistics;
              this.orderParam.userId = res.data.userId;
              this.orderParam.msgToStore = res.data.msgToStore;
              this.orders.orderId = res.data.orderId;
              this.orders.shopId = res.data.shopId;
              this.orders.storeId = res.data.storeId;
              this.orders.userId = this.userId;
              res.data.items.forEach(k => {
                let list = [];

                if (k.storeItem) {
                  list = mapList.get(k.storeItem.cusCode);

                  if (!list || list == undefined || list == null) {
                    list = [];
                  }

                  list.push(k);
                  mapList.set(k.storeItem.cusCode, list);
                } else if (k.itemKey == "DXS|EMPTY_ORDER") {
                  list.push(k);
                  mapList.set("EMPTY_ORDER", list);
                } else {
                  this.$confirm(
                    "The current order does not bind the stock product, please return the audit and inform the seller to make a binding relationship, then review to the warehouse processing!",
                    "Prompt",
                    {
                      confirmButtonText: "retrunToSeller",
                      cancelButtonText: "cancel",
                      type: "warning"
                    }
                  ).then(() => {
                    this.diaReturnOrder = true;
                  });

                  return;
                }
              });

              let list2 = [];

              mapList.forEach((value, key) => {
                console.log(value, key);
                let arr = JSON.parse(JSON.stringify(value[0]));
                arr.variationQuantityPurchased = 0;
                value.forEach(item => {
                  arr.variationQuantityPurchased +=
                    item.variationQuantityPurchased;
                });
                list2.push(arr);
              });

              console.log("mapList", mapList);
              console.log("list2", list2);

              let storeItemList = [];
              let cuscodeList = [];
              let obj = {};

              list2.forEach(p => {
                let obj = new Object();
                obj.children = [];
                obj.image = p.attributeImage ? p.attributeImage : p.image;

                if (p.itemKey === "DXS|EMPTY_ORDER") {
                  p.storeItem = {};
                  p.storeItem.purcahseQty = 0;

                  this.tableList.push({
                    children: [
                      {
                        cusCode: "Empty Gift",
                        encoding: "Empty Gift",
                        sku: "Empty Gift",
                        purcahseQty: "Empty Gift",
                        pickingNum: "Empty Gift"
                      }
                    ],
                    image: p.attributeImage ? p.attributeImage : p.image
                  });

                  console.log("tableList", this.tableList);
                  return;
                } else {
                  p.storeItem.purcahseQty = p.variationQuantityPurchased;

                  if (
                    p.storeItem &&
                    !p.storeItem.component &&
                    p.storeItem.children
                  ) {
                    //套餐
                    (obj.component = false),
                      p.storeItem.children.forEach(i => {
                        i.purcahseQty = p.variationQuantityPurchased;
                        obj.children.push({
                          cusCode: i.cusCode,
                          encoding: i.encoding
                            ? i.encoding.replace(/\s*/g, "")
                            : i.encoding,
                          sku: i.skuName,
                          purcahseQty: Number(i.purcahseQty) * i.rate,
                          pickingNum: 0,
                          address: i.address
                        });

                        if (!cuscodeList.includes(i.cusCode)) {
                          cuscodeList.push(i.cusCode);
                          storeItemList.push({
                            children: [
                              {
                                cusCode: i.cusCode,
                                encoding: i.encoding
                                  ? i.encoding.replace(/\s*/g, "")
                                  : i.encoding,
                                sku: i.skuName,
                                purcahseQty: Number(i.purcahseQty) * i.rate,
                                pickingNum: 0,
                                address: i.address
                              }
                            ],
                            image: p.attributeImage ? p.attributeImage : p.image
                          });
                        } else {
                          storeItemList.forEach(b => {
                            if (b.children[0].cusCode == i.cusCode) {
                              b.children[0].purcahseQty +=
                                Number(i.purcahseQty) * i.rate;
                            }
                          });
                        }
                      });
                  } else {
                    //单品
                    (obj.component = true),
                      obj.children.push({
                        cusCode: p.storeItem.cusCode,
                        encoding: p.storeItem.encoding
                          ? p.storeItem.encoding.replace(/\s*/g, "")
                          : p.storeItem.encoding,
                        sku: p.storeItem.skuName,
                        purcahseQty: p.storeItem.purcahseQty,
                        pickingNum: 0,
                        address: p.storeItem.address
                      });

                    if (!cuscodeList.includes(p.storeItem.cusCode)) {
                      cuscodeList.push(p.storeItem.cusCode);
                      storeItemList.push({
                        children: [
                          {
                            cusCode: p.storeItem.cusCode,
                            encoding: p.storeItem.encoding
                              ? p.storeItem.encoding.replace(/\s*/g, "")
                              : p.storeItem.encoding,
                            sku: p.storeItem.skuName,
                            purcahseQty: p.storeItem.purcahseQty,
                            pickingNum: 0,
                            address: p.storeItem.address
                          }
                        ],
                        image: p.attributeImage ? p.attributeImage : p.image
                      });
                    } else {
                      storeItemList.forEach(b => {
                        if (b.children[0].cusCode == p.storeItem.cusCode) {
                          b.children[0].purcahseQty += p.storeItem.purcahseQty;
                        }
                      });
                    }
                  }

                  this.tableList = storeItemList;

                  this.tableListCopy.push(obj);
                  console.log("storeItemList", storeItemList);
                  console.log("tableList", this.tableList);
                }
              });

              this.$refs.scan.focus();

              setTimeout(() => {
                this.scanNum = "";
                this.$nextTick(() => {
                  this.$refs.scan.focus();
                });
              }, 200);
            } else {
              this.$message.warning(res.msg);
            }
          });
      } else {
        return;
      }
    },

    //扫描枪调用的方法
    packBageOut() {
      if (this.scanNum) {
        if (this.shopee) {
          this.setPackaged({ orderId: this.scanNum });
          setTimeout(() => {
            this.scanNum = "";
          }, 200);
        } else {
          this.setPackaged({ orderId: this.scanNum });
          setTimeout(() => {
            this.scanNum = "";
          }, 200);
        }
      } else {
        return;
      }
    },
    hfkf() {
      this.packTime = utils.getCurrnetTime(new Date());
      this.shopee = JSON.parse(localStorage.getItem("shopee"));
    },
    handleSizeChange(val) {
      this.offset = Number(`${val}`);
      console.log(this.offset);
    },
    handleCurrentChange(val) {
      this.page = this.offset * (Number(`${val}`) - 1);
      this.getOrdersn({
        offset: this.offset,
        page: this.page,
        shopIds: this.shopIdlist,
        storeIds: this.warehouse
      });
    },
    handleSelectionChange(val) {
      console.log(val);
      if (
        val.length === this.choseOrderList.length ||
        val.length === this.orderList2.length
      ) {
        this.chooseAll = true;
      } else {
        this.chooseAll = false;
      }
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    }
  }
};
</script>

<style>
.processedDetail {
  position: absolute;
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px;
  margin-top: 20px;
}

.processedDetail .sbti {
  font-size: 25px;
  color: red;
  font-weight: bold;
}

.processedDetail .sbtiCopy {
  font-size: 25px;
  color: rgb(0, 199, 163);
  font-weight: bold;
}

.processedDetail .orderInfo {
  font-size: 18px;
}

.processedDetail .bvmt {
  margin: 20px 0;
}

.processedDetail .orderInfo_item {
  margin: 0 10px;
}

.processedDetail .order-list-item {
  position: relative;
  padding-bottom: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.processedDetail .order-title {
  border-bottom: 1px #e0e0e0 solid;
}

.processedDetail .order-title-count {
  color: red;
  font-style: inherit;
  margin-left: 10px;
}

.processedDetail .order-query {
  display: flex;
  justify-content: start;
  align-items: center;
  padding: 10px;
  border-bottom: 1px #e0e0e0 solid;
}

.el-tooltip__popper.is-dark {
  background: #000000 !important;
}

.processedDetail .order-query .query {
  position: relative;
  margin-right: 30px;
}

.processedDetail .list-btn {
  padding: 20px 15px;
}

.processedDetail .list-desc {
  margin-left: 15px;
  border-bottom: 1px #eee solid;
}

.processedDetail .list-desc-item {
  font-size: 14px;

  padding-right: 15px;
}

.icon-box {
  width: 22px;
  height: 22px;
  cursor: pointer;
  display: inline-block;
}
.icon-box.svg-box:hover {
  color: tomato;
}

.processedDetail .list-item-status {
  color: red;
}

.processedDetail .didan {
  font-size: 24px;
}

.processedDetail .list-content {
  display: flex;
  justify-content: space-around;
  /* margin: 20px;
	padding: 20px; */
  /* box-shadow: 0 2px 12px 0 rgba(0,0,0,.1); */
}

.processedDetail .order-pic {
  width: 80px;
  height: 80px;
}

img {
  width: 100%;
}

.processedDetail .list-content-left,
.list-content-right {
  display: flex;
}

.processedDetail .list-item-wrapper {
  box-sizing: border-box;
  padding: 15px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.processedDetail .order-selec {
  width: 150px;
  margin: 0 10px;
}

.processedDetail .block-ttp {
  width: 350px !important;
}

.processedDetail .titl_desc_right {
  display: flex;
  justify-content: flex-end;;
  padding: 10px 15px;
}

.processedDetail .order-desc {
  width: 30%;
}

.processedDetail .order-title-desc {
  margin-bottom: 15px;
}

.stroeVisble .el-input__inner {
  width: 99%;
  height: 130px;
  font-size: 30px;
}

.processedDetail .list-price-item,
.shoper-name {
  padding: 2px 0;
}

.processedDetail .list-number,
.list-price {
  margin-left: 40px;
}

.list-price-btn {
  display: flex;
  flex-direction: column;
}

.list-price-btn-item {
  margin-top: 20px;
  margin-left: 0 !important;
  width: 120px;
}

.processedDetail .primary-btn {
  display: inline-block;
  margin: 0 30px;
}

.second-menu-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.asb {
  position: relative;
}

.dialog-wrapper {
  display: flex;
  flex-wrap: wrap;
  position: absolute;
  top: 50px;
  left: -600px;
  bottom: 0;
  right: 0;
  width: 600px;
  background-color: #fff;
  margin: 0 auto;
  z-index: 40;
  box-shadow: 0 0 25px #cac6c6;
}

.dialog-wrapper-item {
  display: inline-block;
  width: 100px;
  height: 100px;
  box-sizing: border-box;
  background-color: #fff;
  padding: 5px;
}

.processedDetail .second-menu {
  display: flex;
  justify-content: flex-start;
  position: relative;
}

.processedDetail .menu-right-btn {
  margin-right: 30px;
  color: #606266;
}

.el-icon-loading:before {
  content: "\E6CF";
  font-size: 20px;
}

.notify-boxw {
  width: 330px;
  height: 80px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  position: absolute;
  top: 150px;
  right: 30px;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 10px;
  z-index: 999999;
}

.processedDetail .second-menu-left {
  display: flex;
}

.icon-gouxuanxuanzhongtai {
  color: rgb(0, 199, 163);
  font-size: 25px;
  margin-left: 20px;
}

.icon-jinggao1 {
  color: rgb(255, 82, 69);
  font-size: 25px;
  margin-left: 20px;
}

.processedDetail .sousuo-box {
  width: 300px;
  margin-right: 20px;
}

.processedDetail .chekbox {
  width: 30px;
  height: 30px;
}

.processedDetail .Pager {
  position: fixed;
  bottom: 0;
  left: 235px;
  right: 0;
  height: 40px;
  line-height: 40px;
  background-color: #fff;
  text-align: right;
}

.processedDetail .el-pagination {
  display: flex;
  justify-content: flex-end;
  margin: 0 10px 10px 0;
}

.processedDetail .nodata {
  margin-top: 100px;
  text-align: center;
  color: #000;
}

.processedDetail .checkallbox {
  margin: 7px;
  padding-left: 5px;
  color: #606266;
  font-size: 14px;
  cursor: pointer;
}

.processedDetail .checkallbox:hover {
  color: #409eff;
}

.processedDetail .checkallbox-oop:hover {
  color: #409eff;
}

.processedDetail .blank {
  color: #606266;
  text-decoration: none;
}

.processedDetail .createOrder {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 10px;
}

.processedDetail .createOrder-item {
  margin: 0 10px;
}

.processedDetail .el-dropdown-link {
  color: #606266 !important;
}

/* 	.loading-box{
		display: inline-block;
		height: 30px;
	} */

.processedDetail .list-desc {
  display: flex;
  align-items: center;
  margin-left: 15px;
  border-bottom: 1px #eee solid;
}

.processedDetail .titl_desc_left {
  display: flex;
}

.processedDetail .chekbox {
  width: 30px;
  height: 30px;
  line-height: 30px;
}

.processedDetail .pic-box {
  display: flex;
  margin: 2px;
  width: 80px;
  height: 80px;
}

.processedDetail .return-item {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 10px;
  font-size: 14px;
}

.processedDetail .return-item-list {
  display: flex;
  align-items: center;
}

.processedDetail .unfold:nth-of-type(n + 4) {
  display: none;
}

.processedDetail .pic-box-desc {
  width: 250px;
  margin-left: 20px;
}

.processedDetail .retrun-reasonr {
  margin-left: 30px;
}

.processedDetail .retrun-reasonr-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 20px;
}

.processedDetail .seller {
  margin-right: 10px;
  font-size: 18px;
}

.processedDetail .return-reasonr-desc {
  box-sizing: border-box;
  padding: 3px 0;
}

.processedDetail .seller-item {
  margin-left: 15px;
  font-size: 14px;
}

.processedDetail .seller-ppc {
  color: red;
}

.processedDetail .ppo_box {
  /* display: flex;
			justify-content: space-between;
		    flex-wrap: wrap;
			height: 40px; */
 
  -webkit-box-align: center;
  align-items: center;
  background: rgb(61, 70, 77);
  color: rgb(255, 255, 255);
  border-top: 10px solid rgb(255, 255, 255);
  border-bottom: 10px solid rgb(255, 255, 255);
  border-radius: 2px;
}

.ppo-item {
  font-size: 20px;
  color: #fff;
  margin-right: 10px;
}

.ordersn-box {
  font-size: 12px;
}

.pic-wrapper {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 5px;
  position: relative;
}

.pic-wrapper-quantity {
  position: absolute;
  top: 0;
  right: 0;
  display: inline-block;
  width: 15px;
  height: 15px;
  line-height: 15px;
  background-color: red;
  font-size: 8px;
  color: #fff;
  text-align: center;
}

.IdScaneArea .el-input__inner {
  height: 130px;
  font-size: 30px;
  margin-top: 10px;
}

.flagbox {
  display: inline-block;
  width: 56px;
  height: 30px;
}

.flagbox .el-radio {
  display: flex;
  align-items: center;
}

.flagbox .el-radio__label {
  padding-left: 5px !important;
}
</style>
